<template>
  <div v-if="!isLandScape">
    <div v-if="!confirmToSpeak" class="overlay-avatar">
      <div class="container-header">
        <img src="../assets/shared/logo-mini.svg" alt="">
        <span v-if="storeSettings.systemSettingsGetters && storeSettings.systemSettingsGetters.avatar_first_name"
              class="text-avatar">{{ storeSettings.systemSettingsGetters.avatar_first_name.value }}</span>
      </div>
      <div class="container-confirm">
        <span class="text-init">Inizia una conversazione <br> con l’assistente virtuale</span>
        <span class="text-sub-init">Proseguendo nella conversazione autorizzo il trattamento dei miei <br> dati personali così come specificato nell’informativa di cui dichiaro <br> di aver preso visione.</span>
        <button @click="confirmInit()" class="btn btn-confirm">
          Inizia una conversazione
          <img src="../assets/chat/chat-confirm.svg" alt="">
        </button>
      </div>
    </div>
    <div id="container-canvas-avatar" style="display: flex" v-show="!storeSettings.showFakeComponentGetters">
      <ComponentAvatar></ComponentAvatar>
    </div>
  </div>
  <!--
  <div style="width: 100vw;margin:0px auto;display: flex;height: 100vh;background: white"
       v-if="storeSettings.showFakeComponentGetters">
    <FakeComponent></FakeComponent>
  </div>
  -->

  <div id="container-orientation-message">
    <div class="orientation-message">
      Per utilizzare l'assistente virtuale si prega di ruotare il dispositivo
    </div>
  </div>
</template>

<script>
import ComponentAvatar from "@/components/avatar/ComponentAvatar";
import {useSettings} from "@/stores/settings";
import {useIntentStore} from "@/stores/intents";
// import FakeComponent from "@/components/fakeComponent";
import {useApiSettingStore} from "@/stores/apiSettings";

export default {
  name: "AvatarView",
  components: {
    // FakeComponent,
    // eslint-disable-next-line vue/no-unused-components
    ComponentAvatar
  },
  setup() {
    const storeSettings = useSettings()
    const storeApiSettings = useApiSettingStore()
    return {
      storeSettings,
      storeApiSettings
    }
  },
  data() {
    return {
      isLandScape: false,
      confirmToSpeak: false
    }
  },
  created() {
    if (this.isInLandscape()) {
      this.isLandScape = true
    }
  },
  mounted() {
    if (this.isInLandscape()) {
      let containerOrientationMessage = document.getElementById('container-orientation-message')
      containerOrientationMessage.style.height = window.innerHeight + 'px'
      containerOrientationMessage.style.display = 'flex'
    } else {
      let containerOrientationMessage = document.getElementById('container-orientation-message')
      containerOrientationMessage.style.display = 'none'
    }
    screen.orientation.onchange = () => {
      if (this.isInLandscape()) {
        let containerOrientationMessage = document.getElementById('container-orientation-message')
        containerOrientationMessage.style.height = window.innerHeight + 'px'
        containerOrientationMessage.style.display = 'flex'
      } else {
        this.isLandScape = false
        let containerOrientationMessage = document.getElementById('container-orientation-message')
        containerOrientationMessage.style.display = 'none'
      }
    }

    useSettings().showFakeComponent = false
    if (useSettings().systemSettingsGetters) {
      document.title = useSettings().systemSettingsGetters.avatar_first_name.value
    }
  },
  updated() {
  },
  methods: {
    isInLandscape() {
      return screen.orientation.angle === 90 || screen.orientation.angle === 270
    },
    confirmInit() {
      this.confirmToSpeak = true
      this.emitter.emit('confirmInit', true)
    }
  },
  beforeUnmount() {
    useSettings().showFakeComponent = false
    useIntentStore().errorNetworkIntent = false
    let canvas = document.getElementsByTagName("canvas")[0]
    canvas.remove()
  },
  unmounted() {
    useSettings().showFakeComponent = false

  }

}
</script>

<style scoped>
.btn-confirm.btn img {
  margin-left: 15px;
}

.btn-confirm.btn {
  background: var(--color-primary);
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 24px;
  margin-right: auto;
  color: var(--color-white);
}

.text-sub-init {
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 16px;
  line-height: 24px;
  color: var(--color-white);
  margin: 30px 0px;
}

.text-init {
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 32px;
  line-height: 44px;
  color: var(--color-white);
}

.overlay-avatar {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 30;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  background: rgba(13, 24, 26, 0.3);
  backdrop-filter: blur(15px);
}

.container-confirm {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: auto 0px;
  justify-content: center;
}

.container-header img {
  margin-right: 10px;
}

.container-header {
  display: flex;
  align-items: center;
}

.text-avatar {
  font-style: normal;
  font-weight: var(--font-weight-regular);
  font-size: 24px;
  line-height: 24px;
  display: flex;
  align-items: center;

  color: var(--color-white);
}
</style>